export enum RiskField {
  Likelihood = 'likelihood',
  Severity = 'severity',
  Description = 'description',
  Index = 'index',
  ResidualLikelihood = 'residualLikelihood',
  ResidualSeverity = 'residualSeverity'
}
